import { useData, useDispatch } from "./DataContext.js";
import { style } from "./Style.js";

import { Transition } from "react-transition-group";
import { TbArrowsMaximize, TbArrowsMinimize } from "react-icons/tb";

import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";

import TimeFormat from "./TimeFormat.js";
import ScoreFormat from "./ScoreFormat.js";
import ErrorsFormat from "./ErrorsFormat.js";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

export default function MainNavbar (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    function openMap () { gDispatch({ type: "openModal", modal: "map" }); }
    function openSolutions () { gDispatch({ type: "openReport", solutionId: null }); }
    function openItems () { gDispatch({ type: "openModal", modal: "items" }); }

    function toggleFullscreen ()
    {
	if (document.fullscreenElement) document.exitFullscreen().catch((err) => {});
	else document.body.requestFullscreen().catch((err) => {});
	//if (props.fullscreenHandle.active) props.fullscreenHandle.exit(); else props.fullscreenHandle.enter();
    }
    

    let themeTitle = (<></>);

    if (gData.state.currentThemeId !== null)
    {
	const theme = gData.content.themes[gData.state.currentThemeId];
	themeTitle = (<span>{theme.title}</span>);
    }

    // CONDITONS

    const allowTime = gData.content.params.timeGameplay && (gData.state.vars.allowTime === undefined || gData.state.vars.allowTime);
    const allowScore = gData.content.params.scoreGameplay && (gData.state.vars.allowScore === undefined || gData.state.vars.allowScore);
    const allowErrors = gData.content.params.errorsGameplay && (gData.state.vars.allowErrors === undefined || gData.state.vars.allowErrors);

    const allowMap = (gData.state.vars.allowMap === undefined || gData.state.vars.allowMap);
    const allowReport = gData.content.params.solutionGameplay && (gData.state.vars.allowReport === undefined || gData.state.vars.allowReport);
    const allowItems = gData.content.params.itemGameplay && (gData.state.vars.allowItems === undefined || gData.state.vars.allowItems);

    let titleClassName = "fs-4";
    let titleStyle = {};
    let buttonVariant = "primary";
    
    switch (gData.gameId)
    {
	case "ada" :
	titleClassName = "text-light fs-3";
	titleStyle = { textShadow: "#AAF 1px 1px 10px" };
	buttonVariant = "light";
	break;

	default:
    }

    return (
	<Navbar expand="lg" className={"user-select-none position-absolute vw-100 " + style.navbar.className} style={style.navbar.style}>
	    <div className="w-100  mx-5 d-flex align-items-center justify-content-between">
		<div className="d-flex gap-5 align-items-center">
		    <Navbar.Text className={titleClassName} style={titleStyle}>{themeTitle}</Navbar.Text>
		    {/* <Navbar.Text className="fs-4"><MoneyFormat value={gData.state.money}/></Navbar.Text> */}
		    {gData.state.currentThemeId === null && (<Navbar.Text className="ms-3 fs-4">2CPO</Navbar.Text>)}
		    {gData.state.currentThemeId !== null && (
			<>
			    {allowScore && (<Navbar.Text className="fs-4 p-0 ms-3"><ScoreFormat/></Navbar.Text>)}
			    {allowErrors && (<Navbar.Text className="fs-4 p-0"><ErrorsFormat/></Navbar.Text>)}
			</>
		    )}
		</div>
		<div>
		    {gData.state.currentThemeId !== null && (
			<>
			    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
			    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
				<div className="d-flex gap-2">
				    {allowTime && (
					<Transition timeout={1000} in={gData.state.currentThemeId === "tuto"} appear>
					    {(state) => (<Navbar.Text className={"fs-4 p-0 translate-from-right-"+state}><TimeFormat value={gData.state.time}/></Navbar.Text>)}
					</Transition>
				    )}
				    {allowMap && (
					<Transition timeout={1000} in={gData.state.currentThemeId === "tuto"} appear>
					    {(state) => (<Button variant="primary" className={"translate-from-right-"+state} onClick={openMap}>{gData.content.params.mapTitle}</Button>)}
					</Transition>
				    )}
				    {allowReport && (
					<Transition timeout={1000} in={gData.state.currentThemeId === "tuto"} appear>
					    {(state) => (<Button variant="primary" className={"translate-from-right-"+state} onClick={openSolutions}>Rapport de mission</Button>)}
					</Transition>
				    )}
				    {allowItems && (<Button variant={buttonVariant} onClick={openItems}>Consulter mes notes</Button>)}
				    <OverlayTrigger placement="bottom" overlay={
					<Popover className={style.popover.className}>
					    <Popover.Body className={style.popover.body.className}>
								     {props.isFullscreen ? (<span>Quitter le mode plein écran</span>) : (<span>Passer en mode plein écran</span>)}
					    </Popover.Body>
					</Popover>
				    }>
					<Button variant={style.button.outlineVariant} className="fs-4 pt-0 pb-1 px-2" onClick={toggleFullscreen}>{props.isFullscreen ? (<TbArrowsMinimize/>) : (<TbArrowsMaximize/>)}</Button>
				    </OverlayTrigger>
				</div>
			    </Navbar.Collapse>
			</>
		    )}
		</div>
	    </div>
	</Navbar>
    );
}
